import type { ChipColor } from '@/lib/taskType';
import type { TemplateStatus } from '@/lib/types';

export const TEMPLATE_STATUS_LABELS: Record<TemplateStatus, string> = {
  new: 'Новый',
  draft: 'Черновик',
  active: 'Запущен',
  paused: 'Приостановлен',
};

export const TEMPLATE_STATUS_COLORS: Record<TemplateStatus, ChipColor> = {
  new: 'default',
  draft: 'warning',
  active: 'success',
  paused: 'default',
};
